import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import i18n from './assets/i18n/i18n';
import vuetify from './plugins/vuetify';
import Vuelidate from 'vuelidate';
import Notifications from 'vue-notification';

import VueYouTubeEmbed from 'vue-youtube-embed'

Vue.config.productionTip = false;

Vue.use(Vuelidate);
Vue.use(Notifications);
Vue.use(VueYouTubeEmbed)

Vue.filter('kb', val => {
    return Math.floor(val / 1024);
});

const fb = require('./firebaseConfig.js');

let app;
// eslint-disable-next-line no-unused-vars
fb.auth.onAuthStateChanged(user => {
    if (!app) {
        app = new Vue({
            el: '#app',
            router,
            store,
            i18n,
            vuetify,
            render: h => h(App)
        });
    }
});